import React from 'react'

import SwitchUi from '@mui/material/Switch'
import { Span } from 'components'

import { SwitchCustom, SwitchStyles } from './styles'
interface SwitchProps extends SwitchStyles {
  // eslint-disable-next-line no-unused-vars
  onClick?: () => void
  state?: boolean
  label?: string
  handleChange?: any
}

export const Switch: React.FC<SwitchProps> = ({
  onClick,
  label,
  handleChange,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  cursor,
  state = false
}) => (
  <SwitchCustom
    marginTop={marginTop}
    marginBottom={marginBottom}
    marginLeft={marginLeft}
    marginRight={marginRight}
    cursor={cursor}
    onClick={onClick}
  >
    <Span text={label} />
    {/* <SwitchStack state={state}> */}
    <SwitchUi checked={state} onChange={handleChange} />
    {/* </SwitchStack> */}
  </SwitchCustom>
)
